export {};
//# sourceMappingURL=scene.js.map